import { render, staticRenderFns } from "./water-contract.html?vue&type=template&id=e97daa90&scoped=true&external"
import script from "./water-contract.js?vue&type=script&lang=js&external"
export * from "./water-contract.js?vue&type=script&lang=js&external"
import style0 from "./water-contract.scss?vue&type=style&index=0&id=e97daa90&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97daa90",
  null
  
)

export default component.exports